<template>
  <div class="main-wrapper">
    <div>
      <layout-header></layout-header>
      <breadcrumb18></breadcrumb18>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar1></sidebar1>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <div>
                <div class="row">
                  <div class="col-sm-6 ml-md-3">
                    <div class="text-left" id="patient_container">
                      <a data-toggle="modal" @click="$bvModal.show('Add_doctor')" class="btn btn-primary mb-2 ml-2"
                        href="">
                        Add Favourite Doctor</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-grid ml-md-3 mt-1">
                <div class="col-md-6 col-lg-4 col-xl-3" v-for="(item, $index) in favourite" :key="item.id"
                  v-show="setOpenReceipts($index)">
                  <div class="profile-widget text-center">
                    <i class="fas fa-heart" style="color: red;float: right; margin-top:12px;"></i>
                    <div class="doc-img">
                      <router-link :to="{
                        name: 'doctor-profile',
                        params: { name: item.name },
                      }">
                        <img class="img-fluid" style="height: 100px;width: 100px;" alt="User Image" v-bind:src="item.image
                          ? config.base_url_for_Image + item.image
                          : loadImg('Doctor Profile.svg')
                          " />
                      </router-link>
                      <a href="javascript:void(0)" @click="remove_favourite_Doctor(item.name)" class="fav-btn">
                        <i class="fas fa-trash"></i>
                      </a>
                    </div>
                    <div class="pro-content">
                      <h3 class="title">
                        <router-link :to="{
                          name: 'doctor-profile',
                          params: { name: item.name },
                        }">{{ item.practitioner_name }}</router-link>
                        <i class="fas fa-check-circle verified"></i>
                      </h3>
                      <p class="speciality">
                        {{ item.healthcare_practitioner_category }}
                      </p>

                      <ul class="available-info">
                        <li>
                          <i class="fas fa-map-marker-alt"></i>{{ item.city }}
                          {{ item.suburb ? "," + item.suburb : "" }}
                        </li>
                        <li v-if="item.total_experience_in_years === 0">
                          -
                        </li>
                        <li v-else-if="item.total_experience_in_years === 1">
                          <i class="fas fa-history"></i>{{ item.total_experience_in_years }} yr.
                        </li>
                        <li v-else>
                          <i class="fas fa-history"></i>{{ item.total_experience_in_years }} yrs.
                        </li>

                      </ul>
                      <div class="row row-sm">
                        <div class="col-6 col-md-6">
                          <router-link class="btn view-btn" :to="{
                            name: 'doctor-profile',
                            params: { name: item.name },
                          }">Profile</router-link>
                        </div>
                        <div class="col-6 col-md-6" v-if="item.booking_appointment === 1">
                          <router-link class="btn book-btn" :to="{
                            name: 'booking',
                            params: { name: item.name },
                          }">Book Now</router-link>
                        </div>
                        <div class="col-6 col-md-6" v-else-if="item.booking_appointment === 0">
                          <b-button disabled class="btn no-book-btn">No Schedule</b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h5 v-if="favourite.length === 0 && !showspinner" style="margin-left: -8%" class="No_data">
                No Doctor Found
              </h5>
              <div class="row justify-content-center" v-if="favourite.length > 12">
                <div>
                  <h5 class="" style="color: #8d8c8c;">Total Patient : {{ total_doctors }}</h5>
                </div>
              </div>
              <!-- pagination  -->

              <div id="pagination" v-if="favourite.length > 10">
                <ul class="pagination justify-content-center">

                  <!-- "Previous" Button -->
                  <li class="page-item" :class="receipt_current === 1 ? 'disabled' : ''">
                    <a href="#" class="page-link" aria-label="Previous"
                      @click.prevent="updateReceiptCurrent(receipt_current - 1)">
                      Previous
                    </a>
                  </li>

                  <!-- Pagination Links (Display 5 at a time) -->
                  <li v-for="page_index in receipt_paginate_total" :key="page_index.id" :class="[
                    'page-item',
                    receipt_current === page_index ? 'active' : ''
                  ]" v-if="page_index >= receipt_current - 2 && page_index <= receipt_current + 2">
                    <a href="#" class="page-link" @click.prevent="updateReceiptCurrent(page_index)">
                      {{ page_index }}
                    </a>
                  </li>

                  <!-- "Next" Button -->
                  <li class="page-item" :class="receipt_current === receipt_paginate_total ? 'disabled' : ''
                    ">
                    <a href="#" class="page-link" aria-label="Next"
                      @click.prevent="updateReceiptCurrent(receipt_current + 1)">
                      Next
                    </a>
                  </li>
                </ul>
              </div>
              <!-- pagination  -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>

    <div>
      <b-modal id="Add_doctor" hide-footer>
        <template #modal-title>
          <h3>Add Doctor to Favourite List</h3>
        </template>
        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row form-row">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <Multiselect v-model="states" :options="states_options" placeholder="Select State" @input="get_city"
                      style="cursor:pointer;">
                    </Multiselect>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <Multiselect v-model="city" :options="city_options" placeholder="Select City" @input="get_doctors"
                      style="cursor:pointer;">
                    </Multiselect>
                  </div>
                </div>
                <div v-if="doctor_list" class="row mt-2">
                  <div class="col-9 col-md-12">
                    <div class="form-group">
                      <input v-model="doctorNameFilter" type="text" class="form-control"
                        placeholder="Search by Doctor's Name" @input="search_doctors" />
                    </div>
                  </div>
                  <div class="row mt-4" v-for="item in doctor_list">
                    <div v-if="item == 'Total Count'"></div>
                    <div v-else class="col-sm-12 m-2 col-md-2">
                      <img class="ml-1" style="border-radius: 100%; width: 55px; height: 50px"
                        :src="'https://app.bhilwarahealthcare.in' + item.image" />
                    </div>
                    <div class="col-sm-12 col-md-6 m-2" style="width: 400px;">
                      <h6 style="font-size: large;">
                        {{ item.practitioner_name }}
                      </h6>
                      <p v-for="item in item.hospitals" style="font-size: 15px;">
                        <i class="fa fa-map-marker" aria-hidden="true" style="font-size: 11px;color:#66CDAA;"></i>
                        {{ item.hospital }}
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 m-2">
                      <button style="font-size: 12px;" class="btn book-btn" size="sm"
                        @click="add_favourite_Doctor(item.name)">Add Favourite</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from 'vue-multiselect'
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
const images = require.context("@/assets/img/doctors");
import axios from "axios";
export default {
  components: {
    Multiselect, // Add this line to register the component
  },

  data() {
    return {
      doctorNameFilter: "",
      city: "",
      city_options: [],
      states: this.patient_state,
      states_options: [],
      favourite: [],
      showspinner: true,
      config: config,
      total_doctors: 0,
      token: localStorage.getItem(JSON.stringify("Authorization")),
      receipt_current: 1,
      receipt_paginate: 8,
      receipt_paginate_total: 0,

    };
  },

  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_my_doctors();
    this.get_states();
    this.set_state_city();
    this.get_appointment_details();
  },

  methods: {

    // pagination start
    setOpenReceipts(i) {
      if (this.receipt_current == 1) {
        return i < this.receipt_paginate;
      } else {
        return (
          i >= this.receipt_paginate * (this.receipt_current - 1) &&
          i < this.receipt_current * this.receipt_paginate
        );
      }
    },

    updateReceiptCurrent(i) {
      this.receipt_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },
    //pagination end

    set_state_city: function () {
      this.states = this.states;
      this.city = this.city;
    },

    //get state 
    get_states: function () {
      const axiosInstance = axios.create({
        baseURL: "https://app.bhilwarahealthcare.in/api/method/",
        headers: {
          Authorization: this.token,
        },
      });
      axiosInstance
        .get("sahaj.finalapi.get_states")
        .then((response) => {
          for (let i in response.data.message) {
            this.states_options.push(response.data.message[i].state);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    //get city
    get_city: function () {
      const axiosInstance = axios.create({
        baseURL: "https://app.bhilwarahealthcare.in/api/method/",
        headers: {
          Authorization: this.token,
        },
      });
      axiosInstance
        .get("sahaj.finalapi.get_city?state=" + this.states)
        .then((response) => {
          this.city_options = [];
          for (let i in response.data.message) {
            this.city_options.push(response.data.message[i].city);
          }
        })
        .catch((error) => { });
    },


    get_doctors: function () {
      const axiosInstance = axios.create({
        baseURL: "https://app.bhilwarahealthcare.in/api/method/",
        headers: {
          Authorization: this.token,
        },
      });

      axiosInstance
        .get(`sahaj.doctor_bot.get_doctors?state=${this.states}&city=${this.city}`)
        .then((response) => {
          this.city_options = [];
          this.doctor_list = response.data.data;
        })
        .catch((error) => { });
    },

    check_practitioner_schedule: function () {
      const axiosInstance = axios.create({
        baseURL: "https://app.bhilwarahealthcare.in/api/method/",
        headers: {
          Authorization: this.token,
        },
      });
      axiosInstance
        .get(
          "sahaj.appointment.check_practitioner_schedule?practitioner=Dr.+Mohit-Chechani-8696490240-Vile+Parle-Mumbai-00001"
        )
        .then((response) => { })
        .catch((error) => { });
      //
    },
    check_availability: function () {
      axios
        .get(
          "https://www.kneexpert.in/api/method/sahaj.appointment.get_availability_data?date=2023-06-28&practitioner=Dr.+Mohit-Chechani-8696490240-Vile+Parle-Mumbai-00001",
          {
            headers: {
              Authorization: "token" + "", //the token is a variable which holds the token
            },
          }
        )
        .then((response) => { })
        .catch((error) => { });
      //
    },

    search_doctors() {
      if (this.doctorNameFilter.trim() === '') {
        this.get_doctors();
      } else {
        const axiosInstance = axios.create({
          baseURL: "https://app.bhilwarahealthcare.in/api/method/",
          headers: {
            Authorization: this.token,
          },
        });

        axiosInstance
          .get(
            "sahaj.doctor_bot.get_doctors?doctor=" + this.doctorNameFilter
          )
          .then((response) => {
            this.doctor_list = response.data.data;
          })
          .catch((error) => {
            console.error("Error searching for doctors:", error);
          });
      }
    },

    get_appointment_details: function () {
      const axiosInstance = axios.create({
        baseURL: "https://app.bhilwarahealthcare.in/api/method/",
        headers: {
          Authorization: this.token,
        },
      });

      const formdata = {
        patient: this.lead_details[0].patient_id,
      };
      axiosInstance
        .post("sahaj.patient_api.get_my_appointment_list_patient", formdata)
        .then((response) => {
          this.appointment_details = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    /* Add Doctor As UnFavourite  */
    async remove_favourite_Doctor(doctor) {
      this.$swal({
        text: "Removing Doctor From Favourite",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        practitioner: doctor,
        patient: this.user_id,
      };
      await CommonApi.post_data("sahaj.finalapi.unfavorite_doctor", data).then(
        (res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.get_my_doctors();
        }
      );
    },

    /* Get My Doctors  */
    async get_my_doctors() {
      const params = new URLSearchParams();
      params.append("patient", this.user_id);
      await CommonApi.get_data("sahaj.api.get_my_doctors", params).then(
        (res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.total_doctors = res.data.length;
            this.favourite = res.data.filter((data) => data.is_favorite !== 0);
            this.receipt_paginate_total = Math.ceil(
              this.favourite.length / this.receipt_paginate
            );
          }
        }
      );
    },


    /* Add Doctor As Favourite  */
    async add_favourite_Doctor(doctor) {
      this.$swal({
        text: "Adding Doctor As Favourite",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        practitionerid: doctor,
        patient: this.user_id,
      };
      await CommonApi.post_data(
        "sahaj.finalapi.add_patient_doctors_list",
        data
      ).then((res) => {
        if (res && res.data.length !== 0 && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        }
        else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/Favourites.vue